import React, { useMemo, useRef } from "react";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";

import { uploadEditorImage } from "../../api/service/blog.service";

const Editor = ({
  value,
  onChange,
  placeholder = "Write here",
  height = "100px",
  label = "",
  className = "",
}) => {
  const quillRef = useRef(null);


  const imageHandler = async () => {
    const input = document.createElement("input");
    input.setAttribute("type", "file");
    input.setAttribute("accept", "image/*");
    input.click();

    input.onchange = async () => {
      const file = input.files[0];
      if (!file) return;

      try {
        const res = await uploadEditorImage(file);
// console.log(res)
        const imageUrl = res?.data;

        const quill = quillRef.current.getEditor();
        const range = quill.getSelection(true);

        quill.insertEmbed(range.index, "image", imageUrl);
        quill.setSelection(range.index + 1);
      } catch (error) {
        console.error("Image upload failed", error);
      }
    };
  };


  const modules = useMemo(
    () => ({
      toolbar: {
        container: [
          [{ header: [1, 2, 3, false] }],
          ["bold", "italic", "underline", "strike"],
          [{ list: "ordered" }, { list: "bullet" }],
          [{ indent: "-1" }, { indent: "+1" }],
          ["link", "image"],
          [{ color: [] }, { background: [] }],
          [{ align: [] }],
          ["clean"],
        ],
        handlers: {
          image: imageHandler, 
        },
      },
    }),
    []
  );

  return (
    <div className={className}>
      {label && <label className="form-label">{label}</label>}

      <ReactQuill
        ref={quillRef}
        theme="snow"
        value={value}
        onChange={onChange}
        modules={modules}
        placeholder={placeholder}
        style={{ height, marginBottom: "50px" }}
      />
    </div>
  );
};

export default Editor;
